import * as React from 'react';

import type { PostType } from '@blockworks/platform/api/strapi';
import { cn } from '@blockworks/ui/utils';

import ResearchTeaser from '@/components/pages/frontpage/components/feature/right/research-teaser';
import RecentResearchHeader from '@/components/sections/right/recent-research-header';

type RecentResearchProps = {
    recentResearch: PostType | null;
    hideHeader?: boolean;
    headerTitle?: string;
    className?: string;
};

const RecentResearch = (props: RecentResearchProps) => {
    const { recentResearch, hideHeader, headerTitle, className } = props;

    return (
        <div className={cn('items-start')}>
            {!hideHeader && <RecentResearchHeader title={headerTitle || 'recent research'} />}
            {recentResearch && (
                <div className={cn('p-10', className)}>
                    <ResearchTeaser headerTitle="Research" article={recentResearch} className="" />
                </div>
            )}
        </div>
    );
};

export default RecentResearch;
